module.exports = __webpack_public_path__ + "static/img/ctlearning_image_square.afec0580.png";